import React from "react";
import { CardContent, Typography, Box, Stack, Divider } from "@mui/material";
import { StyledCard } from "../common/StyledComponents";
import { formatCurrency } from "../../utils/currencyUtils";
import { castEnumForDisplay } from "../../helpers/enumHelpers";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const PaymentCard = ({ payment }) => {
  const paymentDate = new Date(payment.createdAt).toLocaleDateString();
  const paymentTime = new Date(payment.createdAt).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <StyledCard
      sx={{
        borderLeft: "4px solid",
        borderLeftColor: "success.main",
        height: "100%",
      }}
    >
      <CardContent>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          mb={1}
        >
          <Box>
            <Typography variant="h5" fontWeight="bold" color="success.main">
              {formatCurrency(payment.amount)}
            </Typography>
            <Stack direction="row" spacing={0.5} alignItems="center" mt={0.5}>
              <AccessTimeIcon sx={{ fontSize: 14, color: "text.secondary" }} />
              <Typography variant="caption" color="text.secondary">
                {paymentDate} at {paymentTime}
              </Typography>
            </Stack>
          </Box>
          <ReceiptLongIcon color="disabled" />
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        <Stack spacing={1}>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Method
            </Typography>
            <Typography variant="body2" fontWeight="500">
              {payment.paymentMethodName}
            </Typography>
          </Box>

          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Type
            </Typography>
            <Typography variant="body2">
              {castEnumForDisplay(payment.type)}
            </Typography>
          </Box>

          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Ref Code
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontFamily: "monospace", fontWeight: "bold" }}
            >
              {payment.referenceCode || "N/A"}
            </Typography>
          </Box>
        </Stack>
      </CardContent>
    </StyledCard>
  );
};

export default PaymentCard;
